import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { useAuth } from "../lib/auth";
import { getTheme, setTheme } from "../lib/theme";

export function ThemeToggle({ testId = "theme-toggle" }) {
  const { user } = useAuth();
  const [theme, setThemeState] = useState(() => getTheme());

  useEffect(() => {
    if (user && user.id) {
      const t = getTheme(user.id);
      setThemeState(t);
      setTheme(t, user.id);
    }
  }, [user?.id]);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    setThemeState(next);
    setTheme(next, user?.id);
  };

  return (
    <button
      onClick={toggle}
      data-testid={testId}
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      className="inline-flex items-center justify-center w-9 h-9 border border-[#E5E3DB] text-[#68665E] hover:text-[#C84B31] hover:border-[#C84B31] transition-colors duration-150"
    >
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
